import { useMemo } from "react";

import { useHandleDate } from "./use-handle-date";
import * as QueryRepository from "../repository/query";

import type * as Repository from "../repository";
import type * as Type from "../type";

type Props = {
	hotelID: string;
	searchModel: Type.SearchModel;
};
type Result = {
	// チェックイン日での検索
	reservationListByCInDateQueryData: Repository.Query.QueryData.ReservationListQueryData;
	// チェックアウト日での検索
	reservationListByCOutDateQueryData: Repository.Query.QueryData.ReservationListQueryData;
	// 宿泊日での検索
	reservationListByStayDateQueryData: Repository.Query.QueryData.ReservationListQueryData;
};

export const useSearchReservationList = ({
	hotelID,
	searchModel: {
		searchCondition: { year, month, startDate, endDate },
	},
}: Props): Result => {
	const { onFormatDateText } = useHandleDate();
	/**
	 * 検索期間
	 */
	const from = useMemo(
		() => onFormatDateText({ year, month, date: startDate }),
		[month, onFormatDateText, startDate, year],
	);
	/**
	 * 検索期間
	 */
	const to = useMemo(
		() => onFormatDateText({ year, month, date: endDate }),
		[onFormatDateText, year, month, endDate],
	);

	/**
	 * チェックイン日での検索
	 */
	const { reservationListByCInDateQueryData } = QueryRepository.UseCase.useReservationListByCInDateQuery({
		hotelID,
		from,
		to,
	});

	/**
	 * チェックアウト日での検索
	 */
	const { reservationListByCOutDateQueryData } = QueryRepository.UseCase.useReservationListByCOutDateQuery({
		hotelID,
		from,
		to,
	});

	/**
	 * 宿泊日での検索
	 */
	const { reservationListByStayDateQueryData } = QueryRepository.UseCase.useReservationListByStayDateDateQuery({
		hotelID,
		from,
		to,
	});

	return {
		// チェックイン日での検索
		reservationListByCInDateQueryData,
		// チェックアウト日での検索
		reservationListByCOutDateQueryData,
		// 宿泊日での検索
		reservationListByStayDateQueryData,
	};
};
